import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, state } = useLocation();
  const scrollToTop = state?.scrollToTop;

  useEffect(() => {
    if (scrollToTop) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, scrollToTop]);

  return null;
}

export default ScrollToTop;
